import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {ErrorHandler, Injectable, Injector, OnDestroy} from "@angular/core";
import { ApplicationPropertiesService } from "@synisys/idm-application-properties-service-client-js";
import {SessionDataProvider} from "@synisys/idm-session-data-provider-api-js";
import { Observable } from "rxjs/Observable";
import {Subject} from "rxjs/Subject";

@Injectable()
export class PrimeErrorHandlerService extends ErrorHandler implements OnDestroy {

  private destroy$: Subject<boolean> = new Subject<boolean>();

  ADD_ERROR_URL = "/log/error";
  ERROR_LOG_COLLECTING_ENABLED_PATH: string = "properties/error-log-collecting-enabled";
  isEnabled = false;

  constructor(private http: HttpClient,
              private applicationPropertiesService: ApplicationPropertiesService,
              private injector: Injector) {
    super();
    this.checkIsEnabled();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  checkIsEnabled() {
    this.http.get(this.ERROR_LOG_COLLECTING_ENABLED_PATH).takeUntil(this.destroy$).subscribe((value: boolean) => {
      this.isEnabled = value;
    });
  }

  handleError(error: any) {
    if(this.isEnabled) {
      this.storeError(error).takeUntil(this.destroy$).subscribe();
    }
    super.handleError(error);
  }

  storeError(error: any): Observable<any> {
    const currentUserDataProvider = this.injector.get(SessionDataProvider);
    const primeServiceUrl$ = Observable.from(this.applicationPropertiesService.getProperty("prime-service-url"));
    // const primeServiceUrl$ = Observable.of("http://localhost:8899/prime");
    return primeServiceUrl$
      .mergeMap((primeServiceUrl: string) => {
        return currentUserDataProvider.getCurrentUserData().mergeMap((userData: any) => {
          const url = primeServiceUrl + this.ADD_ERROR_URL;
          const params: HttpParams = new HttpParams();
          const headers = new HttpHeaders({"Content-Type": "application/json"});
          const options = {headers, params};

          const errorToStore = {
            message: error.message,
            full_message: error.stack,
            location: window.location.href,
            username: userData.username,
            user_id: userData.userId,
            level: "Error",
            date: new Date()
          };

          return this.http.post(url, JSON.stringify(errorToStore), options);
        });
      });
  }
}

